import React from 'react'
import './style.css'
import renderHTML from 'react-render-html';
import { Typography, Button, Paper, Card, CardContent, Collapse } from '@material-ui/core'
import MaterialIcons from 'material-icons-react'
import Ionicon from 'react-ionicons'

export default class extends React.Component {
    state = {
        topic_collapse : []
    }

    constructor(props) {
        super(props);
    }

    topic_collapse = (key, opt) => () => {
        let topic_collapse = [].concat(this.state.topic_collapse)
        topic_collapse[key] = opt || !this.state.topic_collapse[key]
        this.setState({topic_collapse})
    }

    render() {
        const {
            props,
            topic_collapse
        } = this;

        return(
            <div className='Home_content content_wrapper'>

                    <div className='approval_seal'>
                        <h3 className='MuiTypography-root-1 MuiTypography-subheading-8' 
                        variant='subheading' style={{fontSize: '2rem', textAlign: 'center'}}>
                            Aprovado pela prefeitura e registrado em Cartório!
                        </h3>
                        <MaterialIcons size={68} color={'#242b3a'} icon='gavel'/>
                    </div>

                    <div className='home_topics'>
                        
                        {
                            [
                                {
                                    nome: "Excelente custo benefício por m²",
                                    text: "",
                                    className: "icon-money-line",
                                    color: '#44b380'
                                },
                                {
                                    nome: 'Escrituras individualizadas',
                                    className: 'icon-user',
                                    color: '#44b380',
                                    text: "",
                                },
                                {
                                    nome: "Ruas pavimentadas",
                                    text: "Melhor qualidade de estrutura e saúde pública.",
                                    svg: "M 592.68241,0 H 248.4 L 0,618.08544 h 810.56231 z m -199.1174,39.9924 h 25.7342 l 16.295,90.43416 h -60.60957 z m -3.0802,166.39488 h 32.4907 l 20.5344,114.13152 H 367.03584 Z M 356.7852,560.97 386.5104,416.20248 h 41.20131 L 453.81021,560.97 Z",
                                    viewBox: "0 0 810.56232 618.08545",
                                    color: '#44b380'
                                },
                                {
                                    nome: "Meio fio nas calçadas",
                                    text: "",
                                    svg: "M 0,0 H 14.888 V 90 H 0 Z m 35.902,0 v 5 h -2 V 0 H 16.889 v 90 h 17.014 v -5 h 2 v 5 H 53.916 V 0 Z m 0,76.111 h -2 v -8.889 h 2 z m 0,-17.778 h -2 v -8.889 h 2 z m 0,-17.778 h -2 v -8.889 h 2 z m 0,-17.778 h -2 v -8.889 h 2 z",
                                    viewBox: "0 0 53.916001 90",
                                    color: '#44b380'
                                },
                                {
                                    nome: "Energia elétrica",
                                    text: "",
                                    icon: "ios-flash",
                                    color: '#44b380'
                                },
                                {
                                    nome: "Rede de água",
                                    text: "",
                                    icon: "ios-water-outline",
                                    color: '#44b380'
                                },
                                {
                                    nome: "Praça de convivência com quiosque",
                                    text: "",
                                    viewBox: "0 0 96.424005 100",
                                    svg: "m 81.59,14.448 v 0 C 80.591,14.249 79.942,13.279 80.139,12.279 80.392,11 75.936,8.534 71.137,7.297 70.152,7.042 69.557,6.036 69.81,5.048 70.069,4.061 71.107,3.475 72.061,3.72 c 2.144,0.554 7.688,2.208 10.335,5.096 3.014,-2.242 8.176,-2.454 11.196,-1.854 1,0.199 1.648,1.17 1.449,2.169 -0.196,1.001 -1.169,1.649 -2.166,1.453 -2.854,-0.567 -8.621,-0.067 -9.113,2.412 -0.198,1.001 -1.172,1.65 -2.172,1.452 z M 39.969,73.291 c 3.328,-1.187 6.307,-3.304 8.718,-6.1 1.905,0.895 4.026,1.409 6.271,1.409 0.736,0 1.456,-0.076 2.163,-0.187 l 0.693,-4.3 c 0.18,-1.118 1.145,-1.939 2.277,-1.939 h 2.246 4.748 c 1.652,-2.39 2.666,-5.248 2.666,-8.371 -0.004,-4.554 -2.061,-8.623 -5.297,-11.338 3.235,-2.714 5.293,-6.782 5.293,-11.339 0,-8.171 -6.622,-14.795 -14.795,-14.795 -0.301,0 -0.592,0.026 -0.891,0.045 C 51.126,6.832 43.359,0 34.204,0 22.528,0 13.066,11.095 13.066,24.787 c 0,0.036 0.004,0.072 0.004,0.107 C 5.712,25.75 0,31.998 0,39.584 c 0,6.163 3.765,11.437 9.12,13.663 -0.909,1.921 -1.433,4.058 -1.433,6.324 0,8.169 6.624,14.791 14.796,14.791 1.829,0 3.571,-0.343 5.189,-0.95 v 21.55 h 12.284 l 0.014,-0.041 v -21.63 z m 20.126,-8.808 -2.073,12.85 -0.591,3.784 h -1.124 v 0.002 h -6.3 v -0.002 h -3.211 l -6.027,18.881 h 3.211 l 4.889,-15.316 h 8.579 l 4.891,15.316 h 3.012 L 60.464,84.683 H 76.73 L 71.842,100 h 3.208 l 4.892,-15.317 h 8.58 L 93.407,100 h 3.017 l -5.793,-18.147 0.707,-4.52 2.067,-12.849 H 91.163 62.339 Z m 27.636,16.634 h -0.35 v 0.002 h -6.302 l 0.002,-0.002 h -3.214 l -0.004,0.002 H 60.24 l 0.591,-3.786 h 27.49 z",
                                    color: '#44b380'
                                },                                
                                {
                                    nome : "Urbanização",
                                    text : "Localização de excelência dentro da zona relação a urbana, junto com toda a estrutura esperada",
                                    viewBox: "0 0 74.248353 73.304321",
                                    svg: "m 51.202026,20.582459 v 6.913879 H 42.175537 V 12.115906 L 30.059631,0 H 13.464905 V 14.925964 H 0 V 73.304321 H 74.248352 V 12.069519 Z M 10.600586,58.92395 H 6.6005864 v -4 h 3.9999996 z m 0,-8.240356 H 6.6005864 v -4 h 3.9999996 z m 0,-8.240357 H 6.6005864 v -4 h 3.9999996 z m 0,-8.240295 H 6.6005864 v -4 h 3.9999996 z m 0,-8.240357 H 6.6005864 v -4 h 3.9999996 z m 9,24.721009 h -4 v -4 h 4 z m 0,-8.240357 h -4 v -4 h 4 z m 0,-8.240295 h -4 v -4 h 4 z m 0,-8.240357 h -4 v -4 h 4 z M 24.742432,11.97168 h -4 V 7.9716799 h 4 z m 5.858154,2.75061 h 4 v 4 h -4 z m 0,8.240295 h 4 v 4 h -4 z m 7.333313,31.768067 h -4 v -4 h 4 z m 0,-8.240357 h -4 v -4 h 4 z m 0,-8.240295 h -4 v -4 h 4 z m 9,24.721008 h -4 v -4 h 4 z m 0,-8.240356 h -4 v -4 h 4 z m 0,-8.240357 h -4 v -4 h 4 z m 0,-8.240295 h -4 v -4 h 4 z m 19.79126,7.675232 h -4 v -4 h 4 z m 0,-8.240357 h -4 v -4 h 4 z m 0,-8.240295 h -4 v -4 h 4 z",
                                    color: '#44b380'
                                },
                                
                            ].map((topic, key)=>(
                                <Card key={key+'_topic'} 
                                    style={{
                                        cursor: topic.text.length>1? 'pointer': null,
                                        fontSize: '18px',
                                        textAlign: 'justify',
                                    }}
                                    elevation={0}
                                    onMouseEnter={topic_collapse(key, true)}
                                    onMouseLeave ={topic_collapse(key, false)}
                                    className='home_t'>
                                    <CardContent
                                        style={{display:'flex', flexWrap:'wrap', justifyContent:'center'}}>

                                        {topic.icon?
                                            <Ionicon                                             
                                                icon={topic.icon} 
                                                fontSize={'144px'} 
                                                color={topic.color}
                                                style={{
                                                    display: 'block'
                                                }}
                                                className={'icon'}
                                            />
                                        :                                        
                                        topic.svg?
                                                <svg 
                                                    className="icon-svg-custon-icon" fill={topic.color}
                                                    width={'144px'} height={'144px'} 
                                                    viewBox={topic.viewBox} 
                                                    rotate="0" 
                                                    style={{
                                                        display: "block"
                                                    }}>
                                                      <path d={topic.svg}>
                                                      </path>
                                                </svg>
                                        :topic.className?
                                            <i 
                                                className={topic.className} 
                                                style={{
                                                    display: 'block',
                                                    fontSize : '144px',
                                                    color : topic.color,
                                                }} />
                                        :null}


                                        

                                        <Typography>
                                            {topic.nome}
                                        </Typography>
                                        <Collapse style={{marginTop:'5px'}} in={this.state.topic_collapse[key] || false}>
                                            {topic.text}
                                        </Collapse>
                                    </CardContent>
                                </Card>
                            ))
                        }
                    </div>

                <div className='home__wrapper_content'>
                    {renderHTML(props.conteudo)}
                </div>
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/website/home/component.js